import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../../../components/Icons/ArrowDownIcon";

function Checkbox(props) {
  const { title, options, value, t, onChange, isLastest } = props;
  const [show, $show] = useState(true);
  // console.log(options);
  const onChangeCheckbox = (e, val) => {
    const data = value;
    if (data.includes(val) == false) {
      data.push(val);
    } else {
      data.splice(data.indexOf(val), 1);
    }
    // console.log('Checkbox=>onChangeCheckbox->data', JSON.stringify(data))
    onChange(data);
  };
  return (
    <div
      className={
        "pt-3 pb-3 px-0" +
        (isLastest ? "pb-9" : " border-b border-solid border-black/[.15]")
      }
    >
      <div
        className="flex items-center justify-between text-base font-semibold text-black cursor-pointer"
        onClick={() => $show(!show)}
      >
        <span>{title}</span>
        {show && <ArrowDownIcon className="rotate-180 w-[12px] h-[12px]" />}
        {!show && <ArrowDownIcon className="w-[12px] h-[12px]" />}
      </div>
      <div
        className={
          "flex items-center justify-start flex-wrap gap-[14px] pt-5 pb-2" +
          (show ? "" : " hidden")
        }
      >
        {options?.length > 0 &&
          options.map((item, index) => {
            // const isCheck = value.includes(''+item.value)
            return (
              <>
                <label
                  key={index}
                  className={
                    "cursor-pointer checkbox-gradient border border-solid border-[#000] rounded-[8px]" +
                    (value && value.indexOf(item.value) > -1
                      ? " checked border-transparent"
                      : "")
                  }
                  onClick={(event) => onChangeCheckbox(event, item.value)}
                >
                  <div className={"h-[40px] rounded-lg p-[1px] gradient"}>
                    <div className="block rounded-[6px] w-full h-full py-2 px-4">
                      <span>{t(item.title)}</span>
                    </div>
                  </div>
                </label>
              </>
            );
          })}
      </div>
    </div>
  );
}

Checkbox.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  isLastest: PropTypes.bool,
};

export default Checkbox;
